import hljs from 'highlight.js';
window.hljs = hljs;
